import { TV_PACKAGES_ADD, LOGOUT_REQUEST, RESET_STATE } from "../constants/actionTypes";

const INITIAL_STATE = {
  tvPackages: [],
};

const applyAddTvPackages = (state, action) => ({
  ...state,
  tvPackages: action.payload,
});

const tvPackageReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TV_PACKAGES_ADD:
      return applyAddTvPackages(state, action);
    case LOGOUT_REQUEST:
      return INITIAL_STATE;
    case RESET_STATE:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default tvPackageReducer;
